export const AppPermissions = {
    // Main permissions
    PortalAccess: ["TMTAD.PortalAccess@TMTAD"],
}